export const ccaDropOffLocationType = [
    { id: "door_to_door", name: "Door To Door" },
    { id: "fixed_location", name: "Fixed Location" },
    { id: "both", name: "Both" },
  ];